import React, { useEffect, useState } from "react";
import userAPI from "../../api/UserApi";
import { showError } from "../../utils/toastUtils";
import { Link } from "react-router-dom";
import { getDateAgo } from "../../helper/Helper";

function Orders() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    fetchMyOrders();
  }, []);

  const fetchMyOrders = async () => {
    try {
      const res = await userAPI.fetchMyOrders();
      if (res.code === 200) {
        setOrders(res.data);
      }
    } catch (err) {
      showError(err.message);
    }
  };

  return (
    <>
      <div className="my-acount-content account-orders mb-5">
        {orders && orders.length > 0 ? (
          <div className="account-orders-wrap">
            <h5 className="title">Order History ({orders.length})</h5>
            <div className="wrap-account-order">
              <table>
                <thead>
                  <tr>
                    <th className="text-md fw-medium">Order ID</th>
                    <th className="text-md fw-medium">Date</th>
                    <th className="text-md fw-medium">Amount</th>
                    <th className="text-md fw-medium">Status</th>
                    <th className="text-md fw-medium"></th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((order, index) => (
                    <tr className="tf-order-item">
                      <td className="text-md">
                        <Link
                          to={`/users/order-details`}
                          className="text-primary"
                          state={{
                            orderId: order._id,
                          }}
                        >
                          #{order.orderId}
                        </Link>
                      </td>
                      <td className="text-md">
                        {getDateAgo(order?.orderDate)}
                      </td>
                      <td className="text-md">₹ {order.total} /-</td>
                      <td className="text-md text-delivered">
                        {order.status.toUpperCase()}
                      </td>
                      <td>
                        <Link
                          to={`/users/order-details/${order.id}`}
                          className="view-detail"
                        >
                          Detail
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className="account-no-orders-wrap">
            <img
              src={`${process.env.PUBLIC_URL}/images/section/account-no-order.png`}
              alt="No Order Found"
            />
            <div className="display-sm fw-medium title">
              You haven’t placed any order yet
            </div>
            <div className="text text-sm">
              It’s time to make your first order
            </div>
            <Link
              to="/shop"
              className="tf-btn animate-btn d-inline-flex bg-dark-2 justify-content-center"
            >
              Shop Now
            </Link>
          </div>
        )}
      </div>
    </>
  );
}

export default Orders;
